export default __webpack_public_path__ + "static/media/oval.dfc01345.svg";